import Vue from "vue";
export const MensajesDeCarga = new Vue();
export const MensajesDeError = new Vue();
export const MensajesDeRespuesta = new Vue();




// WEBPACK FOOTER //
// ./src/utils/BusesDeEventos.js